/**
 * Speakers for ETH México 2026 (/ETHMX2026).
 * Each entry: { image, width, link?, role? }
 * - image: filename under public/images/
 * - width: CSS width (e.g. "204px") — same as partners in ethmx2026Partners.js
 * - link: optional profile URL (X, LinkedIn, etc.)
 * - role: optional subtitle
 */
export const speakers = [
  {
    link: "https://x.com/reidbenj",
    image: "ben-reid.png",
    width: "200px",
  },
  {
    link: "",
    image: "Ricardo-Ortiz.png",
    width: "200px",
  },

  {
    link: "https://x.com/sodofi_",
    image: "sophia-dew.png",
    width: "200px",
  },
  {
    link: "https://x.com/austingriffith",
    image: "austingriffith.png",
    width: "200px",
  },
  {
    link: "https://x.com/blockbyvlog",
    image: "daniel-ortega.png",
    width: "200px",
  },
  {
    link: "https://x.com/SuperRareJohn",
    image: "john-crain.png",
    width: "200px",
  },
  {
    link: "https://x.com/rhtkpr",
    image: "rohit-kapoor.png",
    width: "200px",
  },
  {
    link: "https://x.com/rareperkins",
    image: "jonathan-perkins.png",
    width: "200px",
  },
  {
    link: "https://x.com/SuperRareKeegan",
    image: "keegan-ead.png",
    width: "200px",
  },
  {
    link: "https://x.com/SuperRareChar",
    image: "charles-crain.png",
    width: "200px",
  },
  {
    link: "https://x.com/stablecoing",
    image: "Guillermo-goncalvez.png",
    width: "200px",
  }, 
  {
    link: "",
    image: "aldo-ricardo.png",
    width: "200px",
  },
  {
    link: "",
    image: "juana-mier.png",
    width: "200px",
  },
  {
    link: "https://x.com/abrahamcr",
    image: "abraham-cobos.png",
    width: "200px",
  },
  {
    link: "https://x.com/BerpuAfterHours",
    image: "miguel-bernal.png",
    width: "200px",
  },

  {
    link: "https://x.com/Wenlopezn",
    image: "wendy-lopez.png",
    width: "200px",
  },
  {
    link: "https://x.com/Lalogarciax",
    image: "lalo-garcia.png",
    width: "200px",
  },
  {
    link: "https://x.com/anthonysurfermx",
    image: "anthony-chavez.png",
    width: "200px",
  },
  {
    link: "https://x.com/anabelen_gf",
    image: "ana-belen.png",
    width: "200px",
  },
  {
    link: "https://x.com/ValeCreativo",
    image: "valentin-martinez.png",
    width: "200px",
  },
];
